import { HttpInterceptorFn } from '@angular/common/http';
import * as Sentry from '@sentry/angular';

import { environment } from '../../../environments/environment';

export const sentinelHeaders: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }

  let headers = req.headers.set('X-Application-ID', 'sentinel');

  try {
    const traceData = Sentry.getTraceData();
    if (traceData['sentry-trace']) {
      headers = headers.set('sentry-trace', traceData['sentry-trace']);
    }
    if (traceData['baggage']) {
      headers = headers.set('baggage', traceData['baggage']);
    }
  } catch {
    return next(req.clone({ headers }));
  }

  return next(req.clone({ headers }));
};
